module.exports = __webpack_public_path__ + "front/img/success-kv.558d7722.png";